import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index.js'
import {AA_ACCOUNT_TYPE} from '../common/constants'
const Home = () => import('../pages/Home.vue')
const Dashboard = () => import('../pages/Dashboard/DashboardPage.vue')
const Rules = () => import('../pages/Rule/Rules.vue')
const Project = () => import('../pages/Project.vue')
const Evidence = () => import('../pages/Evidence/Evidence.vue')
const Measures = () => import('../pages/Measures.vue')
const Error = () => import('../pages/Error.vue')
const NotFound = () => import('../pages/NotFound.vue')
const SaleManagement = () => import('../pages/Yomi/Dashboard.vue')
const ProjectList = () => import('../pages/Yomi/ProjectList.vue')
const EvidenceYomi = () => import('../pages/Yomi/Evidence.vue')

Vue.use(Router)

export const constantRouters = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if (store.state.account_type === AA_ACCOUNT_TYPE) {
        next()
        return
      }
      next('/error')
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      if (store.state.account_type === AA_ACCOUNT_TYPE) {
        next()
        return
      }
      next('/error')
    }
  },
  {
    path: '/project',
    name: 'Project',
    component: Project,
    beforeEnter: (to, from, next) => {
      if (store.state.account_type === AA_ACCOUNT_TYPE) {
        next()
        return
      }
      next('/error')
    }
  },
  {
    path: '/rules',
    name: 'Rules',
    component: Rules,
    beforeEnter: (to, from, next) => {
      if (store.state.account_type === AA_ACCOUNT_TYPE) {
        next()
        return
      }
      next('/error')
    }
  },
  {
    path: '/evidence',
    name: 'Evidence',
    component: Evidence,
    beforeEnter: (to, from, next) => {
      if (store.state.account_type === AA_ACCOUNT_TYPE) {
        next()
        return
      }
      next('/error')
    }
  },
  {
    path: '/measures',
    name: 'Measures',
    component: Measures,
    beforeEnter: (to, from, next) => {
      if (store.state.account_type === AA_ACCOUNT_TYPE) {
        next()
        return
      }
      next('/error')
    }
  },

  {
    path: '/sp',
    name: 'SaleManagement',
    component: SaleManagement
  },

  {
    path: '/sp/project',
    name: 'ProjectList',
    component: ProjectList
  },

  {
    path: '/sp/evidence',
    name: 'Evidence',
    component: EvidenceYomi
  },

  {
    path: '*',
    name: 'Not Found',
    component: NotFound
    // beforeEnter: (to, from, next) => {
    //   next('/error')
    // }
  },
  {
    path: '/error',
    name: 'Error',
    component: Error
  }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouters,
  mode: 'history'
})
const router = createRouter()

export default router



// WEBPACK FOOTER //
// ./src/router/index.js